import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {OrderHistoryError} from 'app/core/components/error-page/order-history-error';
import {Sale} from 'app/data/models/sale';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OrderDetailsActions = createActionGroup({
  source: 'Order Details',
  events: {
    'Load Order': props<{saleNumber: string}>(),
    'Load Order Success': props<{order: Sale}>(),
    'Load Order Failure': props<{error: OrderHistoryError}>(),
    'Navigate Back': emptyProps(),
  },
});
